if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        this.stopWatchingPinchZoom();
        this.stopWatchingSlides();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.watchPinchZoom();
        this.watchSlides();
      }

      // Da telefono lo zoom e' una fila da scorrere di lato: quando ci si ferma su una
      // foto, il video che si stava guardando si mette in pausa invece di continuare
      // a suonare fuori schermo.
      watchSlides() {
        const content = this.querySelector('.product-media-modal__content');
        if (!content || !window.matchMedia('(max-width: 749px)').matches) return;
        this.slidesContent = content;
        this.onSlidesScroll = () => {
          clearTimeout(this.slidesTimer);
          this.slidesTimer = setTimeout(() => {
            const current = [...content.children].find((element) => {
              const rect = element.getBoundingClientRect();
              return rect.width > 0 && Math.abs(rect.left) < content.clientWidth / 2;
            });
            if (current && current.tagName !== 'DEFERRED-MEDIA') window.pauseAllMedia();
          }, 150);
        };
        content.addEventListener('scroll', this.onSlidesScroll, { passive: true });
      }

      stopWatchingSlides() {
        if (!this.onSlidesScroll) return;
        clearTimeout(this.slidesTimer);
        this.slidesContent.removeEventListener('scroll', this.onSlidesScroll);
        this.onSlidesScroll = null;
      }

      // Da telefono le foto si aprono adattate allo schermo, con la versione leggera.
      // Appena si allarga con due dita, chiediamo al browser quella grande delle foto
      // a schermo, cosi' i dettagli restano nitidi senza farla scaricare a chi guarda
      // soltanto.
      watchPinchZoom() {
        if (!window.visualViewport || !window.matchMedia('(max-width: 749px)').matches) return;
        this.onViewportResize = () => {
          if (window.visualViewport.scale < 1.2) return;
          const screen = document.documentElement;
          this.querySelectorAll('.product-media-modal__content > img').forEach((img) => {
            const rect = img.getBoundingClientRect();
            const onScreen = rect.right > 1 && rect.left < screen.clientWidth - 1 && rect.bottom > 1 && rect.top < screen.clientHeight - 1;
            if (onScreen && img.getAttribute('sizes') !== '250vw') img.setAttribute('sizes', '250vw');
          });
        };
        window.visualViewport.addEventListener('resize', this.onViewportResize);
      }

      // Se si chiude lo zoom con la pagina ancora ingrandita, la riporta a misura: un
      // maximum-scale=1 messo per un attimo e' l'unico comando che i telefoni rispettano.
      stopWatchingPinchZoom() {
        if (!this.onViewportResize) return;
        window.visualViewport.removeEventListener('resize', this.onViewportResize);
        this.onViewportResize = null;
        const viewport = document.querySelector('meta[name="viewport"]');
        if (!viewport || window.visualViewport.scale <= 1.01) return;
        const content = viewport.getAttribute('content');
        viewport.setAttribute('content', content + ', maximum-scale=1');
        setTimeout(() => viewport.setAttribute('content', content), 300);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        // Centra di lato la foto toccata. Con la foto larga di Dawn equivale al calcolo di
        // prima; nella fila orizzontale del telefono porta sulla foto giusta, mentre
        // quello di prima riportava sempre alla prima foto.
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = activeMedia.offsetLeft - (container.clientWidth - activeMedia.offsetWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
